import { ApiService } from "../apiService";

export class CompaniesService extends ApiService {
    constructor() {
        super();

        this.path = '/Companies';
    }

    getCompanies() {
        return this.get(this.path);
    }

    getCompany(companyId) {
        return this.getById(this.path, companyId);
    }

    getBlueprints(companyId) {
        return this.getById(this.path + "/getBluePrints", companyId);
    }

    createCompany(newCompany, logo) {
        return this.post(this.path, newCompany, logo);
    }

    saveFileLogo(file) {
        return this.saveFile(this.path + "/saveFile", file);
    }

    updateCompany(updatedCompany) {
        return this.put(this.path, updatedCompany);
    }

    deleteCompany(id) {
        return this.delete(this.path, id);
    }

    undoCompany(idCompany) {
        return this.postUndo(this.path + "/undoDeleteCompany", idCompany);
    }
}